// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/work_step.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/work_step.proto.
 */
export const file_studyo_today_planners_v1_resources_work_step = /*@__PURE__*/
  fileDesc("CjJzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3dvcmtfc3RlcC5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyJNCghXb3JrU3RlcBIKCgJpZBgBIAEoCRINCgV0aXRsZRgCIAEoCRIQCghkdXJhdGlvbhgDIAEoBRIUCgxpc19jb21wbGV0ZWQYBCABKAhCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the message studyo.today.planners.v1.resources.WorkStep.
 * Use `create(WorkStepSchema)` to create a new message.
 */
export const WorkStepSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_work_step, 0);

